// Modal registry — module-level singleton. Mirrors the action registry shape
// (project register hook deferred to whenever the first project-specific
// modal lands; .design.md Project-specific extensions).
//
// Built-ins are registered from the host at first render (see registerBuiltins).
// Importing this module by itself does not register anything — that way
// hot-reload doesn't pile duplicates and tests can start from a clean slate.

import type { ModalDef } from "./types";

const registry = new Map<string, ModalDef>();

export function registerModal(modal: ModalDef): void {
  if (!modal || !modal.id) return;
  registry.set(modal.id, modal);
}

export function getModal(id: string): ModalDef | undefined {
  return registry.get(id);
}

export function listModals(): ReadonlyMap<string, ModalDef> {
  return registry;
}

export function _clearModalsForTests(): void {
  registry.clear();
}
